import {WorkUpdateSubscription} from "src/app/modules/shared/interfaces/WorkUpdate.interface";
import {Injectable} from "@angular/core";
import {
  Subscription,
  fromEvent,
  debounceTime,
  distinctUntilChanged,
  filter,
} from "rxjs";
import {RealtimeInvalidationService} from "src/app/modules/shared/services/realtime-invalidation.service";

@Injectable({
  providedIn: "root",
})
export class WorksListsService {
  constructor(
    private readonly realtimeInvalidationService: RealtimeInvalidationService
  ) {}

  public subscribeToScroll(callback: () => void): Subscription {
    return fromEvent(globalThis, "scroll")
      .pipe(debounceTime(150), distinctUntilChanged())
      .subscribe(() => {
        if (
          window.innerHeight + window.scrollY * 1.1 >=
          document.body.offsetHeight
        ) {
          callback();
        }
      });
  }

  public subscribeToWorkUpdates(options: WorkUpdateSubscription): () => void {
    const listCleanup = options.listUpdated
      ? this.realtimeInvalidationService.subscribe(
          "listUpdated",
          options.listUpdated,
          {key: "works-lists:lists"}
        )
      : undefined;
    const subscription = this.realtimeInvalidationService.workUpdates$
      .pipe(
        filter((update) => options.apply(update)),
        filter(
          (update) =>
            options.shouldRefresh?.(update) ??
            (["custom", "remainingDuration"].includes(
              options.sortBy?.() ?? ""
            ) ||
              (!update.local &&
                ["add", "remove", "follow", "unfollow", "update"].includes(
                  update.operator
                )))
        ),
        debounceTime(180)
      )
      .subscribe(() => options.refresh?.());
    return () => {
      subscription.unsubscribe();
      listCleanup?.();
    };
  }
}
